import { render, staticRenderFns } from "./subsidy.vue?vue&type=template&id=15b63c54&"
import script from "./subsidy.vue?vue&type=script&lang=js&"
export * from "./subsidy.vue?vue&type=script&lang=js&"
import style0 from "./subsidy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports